import React, { useEffect, useRef } from 'react';
import { IoMdClose } from 'react-icons/io';
import './style.scss';

const FullScreenModal = ({
  classNames,
  children,
  show,
  onClose,
  scrollToEnd,
}) => {
  const fullScreenRef = useRef(null);

  // useEffect(
  //   () => {
  //     if (
  //       screen.orientation.type === 'portrait-primary' &&
  //       show &&
  //       scrollToEnd
  //     ) {
  //       fullScreenRef.current.firstChild.scrollLeft = 2880;
  //     }
  //   },
  //   [show, screen.orientation.type],
  // );

  if (!show) return null;

  return (
    <div
      className={[...classNames, 'full-screen-modal'].join(' ')}
      ref={fullScreenRef}
    >
      {children}
      <IoMdClose
        onClick={onClose}
        className="full-screen-modal__close"
        color="#FFF"
        size={28}
        style={{ zIndex: 20 }}
      />
    </div>
  );
};

export default FullScreenModal;
